export class SubCategoryWiseActRevenue{
    categoryName:string;
    subCategoryName:string;
    tdyActualRevenue:string;
    tdyLastYearRevenue:string;
    mtdActual:string;
    mtdLastYear:string;
    ytdActual:string;
    ytdLastYear:string;
    tdyVob:string;
    mtdVob:string;
    ytdVob:string;
    tdyVoly:string;
    mtdVoly:string;
    ytdVoly:string;
    divisionCode?:string;

}